module.exports = {"id":"200434","name":"Luis Pedro Cavanda","rating":"71","photo":"./data/images/photos/0/200434.png","club":{"name":"Standard Liège","logo":"./data/images/clubs/StandardLiege.png"},"positions":["DD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LuisPedroCavanda0.json
// module id = 2617
// module chunks = 0